module.exports = __webpack_public_path__ + "img/hohlschnitt_kieferngruen_ral6028.fc94994e.jpg";